import { FetchRequestError } from "./FetchRequestError";

export class FetchUnauthorizedError extends FetchRequestError {}
